import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { IOptionsResponse } from '../../../common/common.types'
import { setAltHomeResidenceOptions } from '../store/options.actions'

export function* getAltHomeResidenceOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getAltHomeResidenceOptions,
    ])
    const { entity } = response
    yield put(setAltHomeResidenceOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getAltHomeResidenceOptions() error: ${e}`))
  }
}

export function* getAltHomeResidenceOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getAltHomeResidenceOptions)
}
